// src/pages/Wizards.js

import React, { useState } from 'react';
import ReactPlayer from 'react-player'
import axios from 'axios';
import ReactSwitchsupport from 'react-switch';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { CompleteIcon } from '../icons';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';
import NoticeModal from '../Components/NoticeModal/NoticeModal';
import { useNavigate } from 'react-router-dom'; // Optional for navigation
import verified from '../../assets/icons/support/verified.gif'
import Captcha from '../Components/Captcha/Captcha';
import PluginList from '../pages/PluginList';

import './wizards.scss';


const Wizards = () => {
  const [testMessage, setTestMessage] = useState('');
  const [passview, setPassview] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [settings, setSettings] = useState({
    // webhook: false,
    global_webhook: '',
    recipiantmail: '',
    active_user_activity: false,
    active_security_settings: false,
    active_site_theme_security: false,
    active_site_page_post_security: false,
    active_site_media_security: false,
    active_site_menu_security: false,
    active_site_widgets_security: false,
    active_site_woocommerce_security: false,
    active_site_comment_security: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false); // For submission state
  const navigate = useNavigate(); // Optional for navigation

  // Handle toggle switch change
  const handleToggle = (setting) => (checked) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [setting]: checked,
    }));
  };


  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    type: 'confirmation',
    title: '',
    message: '',
    onConfirm: () => { },
    confirmText: 'Confirm',
    declineText: 'Cancel'
  });

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };
  const handleViewpass = () => {
    passview === true ? setPassview(false) : setPassview(true)
  }

  const handleChange = e => {
    setSettings(prev => ({ ...prev, global_webhook: e.target.value }));
  }

  const handleRecipiantmail = e => {
    setSettings(prev => ({ ...prev, recipiantmail: e.target.value }))
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const url = `${appLocalizer.wpntsUrl}/wpnts/v1/updatewizards`;
    const updateWizards = {
      global_webhook: settings.global_webhook,
      recipiantmail: settings.recipiantmail,
      active_user_activity: settings.active_user_activity,
      active_security_settings: settings.active_security_settings,
      active_site_theme_security: settings.active_site_theme_security,
      active_site_page_post_security: settings.active_site_page_post_security,
      active_site_media_security: settings.active_site_media_security,
      active_site_menu_security: settings.active_site_menu_security,
      active_site_widgets_security: settings.active_site_widgets_security,
      active_site_woocommerce_security: settings.active_site_woocommerce_security,
      active_site_comment_security: settings.active_site_comment_security,
      setupComplete: true,
    };

    try {
      const response = await axios.post(
        url,
        { updateWizards },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-WP-NONCE': appLocalizer.nonce,
          },
        }
      );

      // Check if the response indicates success (1)
      if (response.data === 1) {
        // Clear localStorage items
        Object.keys(localStorage).forEach((key) => {
          if (key.startsWith('wpnts_')) {
            localStorage.removeItem(key);
          }
        });

        setModalConfig({
          isOpen: true,
          type: 'toast',
          title: 'success',
          message: 'Settings updated successfully',
          position: 'top-right'
        });

        // Navigate and reload
        navigate('/');

        window.location.reload();

      } else {
        throw new Error('Server returned unsuccessful status');
      }
    } catch (err) {
      console.error('Error during submission:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNext = () => {
    if (currentStep < 6) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };



  /**
   * 
   * @returns Other configurations
   */

  const handleTestWebhook = async (e) => {
    e.preventDefault();

    const { global_webhook } = settings;

    if (!global_webhook) {
      setModalConfig({
        isOpen: true,
        type: 'toast',
        title: 'Error!',
        message: 'Please enter a webhook URL.',
        position: 'top-right'
      });
      return;
    }

    const url = `${appLocalizer.wpntsUrl}/wpnts/v1/slack_webhook_sending_test`;

    try {
      const response = await axios.post(
        url,
        { global_webhook, testMessage },
        {
          headers: {
            'content-type': 'application/json',
            'X-WP-NONCE': appLocalizer.nonce,
          },
        }
      );

      if (response.data === 1) {
        setModalConfig({
          isOpen: true,
          type: 'toast',
          title: 'success',
          message: 'Webhook test message sent successfully.',
          position: 'top-right'
        });
        setTimeout(closeModal, 3000);

        // Reset the testMessage
        setTestMessage('');
      } else {
        setModalConfig({
          isOpen: true,
          type: 'toast',
          title: 'Error!',
          message: 'Unexpected response from the server.',
          position: 'top-right'
        });
        setTimeout(closeModal, 3000);

      }
    } catch (error) {
      setModalConfig({
        isOpen: true,
        type: 'toast',
        title: 'Error!',
        message: 'Failed to send the webhook test message.',
        position: 'top-right'
      });
      setTimeout(closeModal, 3000);

    }
  };



  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="wizard-step">
            <div className="welcome-section">
              <div className="welcome-message">
                <h3>Step 1: Welcome to 'Activity Guard' – Real Time Notifier to Slack/Mail/Log </h3>
                <p>This tool will help you increase site security, monitor your WordPress support forum, and track all user and system activity, keeping you updated on critical issues directly through Slack, email, and the Activity Log Panel.</p>
                <p>Let’s walk you through the setup process to get started.</p>

              </div>
              <div className="welcome-image">
                <img src="https://functiondeck.com/wp-content/themes/wpxperties/assets/img/feature/order-status.gif" alt="Welcome to WP Notifier" />
              </div>
            </div>
            <div className="plugin-steps">
              <div className="step">
                <div className="step-number">1</div>
                <p>Configure Slack</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <p>Quick Security Activation</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <p>Login Security</p>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <p>WordPress Forum Tracker</p>
              </div>
              <div className="step">
                <div className="step-number">5</div>
                <p>Start Monitoring</p>
              </div>

            </div>
          </div>
        );
      case 2:
        return (
          <div className="wizard-step">
            <h3>Step 2: Webhook Settings</h3>
            <div className="wpnts-switch-sitessecurityissues">
              <div className="webhooks-panel">
                <div className="webhook-settings-panel">

                  <div className="add-webhook">
                    <div className="formInput setup-step-2">
                      <label htmlFor="global_webhook">Webhook URL
                        <Tippy content="Add slack webhook. This will integrate the slack with your site and send you notification any system or log event">
                          <span className="wcs_title">
                            <HelpOutlineIcon className="wcs_tooltip_icon" />
                          </span>
                        </Tippy>
                      </label>

                      <div className="wpnts-setting">
                        <div className="passimg" onClick={handleViewpass}>
                          {passview === false ? <VisibilityOffIcon className='passVisibility' /> : <VisibilityIcon className='passVisibility' />}
                        </div>
                        <input
                          type={passview === true ? "text" : "password"}
                          placeholder="Add webhook"
                          name="global_webhook"
                          required
                          onChange={handleChange}
                          value={settings.global_webhook}
                        />
                      </div>

                    </div>

                    <div className="test-webhook">

                      <div className="formInput">
                        <p>➡️ Verify the webhook is connected !</p>
                        <label htmlFor="testMessage">Add your message
                          <Tippy content="This fields help you to ensure the webhook is connected. Add your test message here and hit 'Test Webhook' button. And check the slack if you received any response.">
                            <span className="wcs_title">
                              <HelpOutlineIcon className="wcs_tooltip_icon" />
                            </span>
                          </Tippy>

                        </label>
                        <div className="wpnts-setting">
                          <input
                            type="text"
                            placeholder="Enter test message"
                            name="testMessage"
                            value={testMessage}
                            onChange={(e) => setTestMessage(e.target.value)}
                          />
                        </div>
                      </div>
                      <button className="save-webhook" onClick={handleTestWebhook}>
                        TEST WEBHOOK
                      </button>
                    </div>

                  </div>

                  <div className="add-email">
                    <div className="formInput">
                      <label className="form-feature-sub-heading" htmlFor="recipiantmail">Recepiant Mail

                        <Tippy content="Add mail which will send you all the logs to your mail. Currently its in beta mode and avliable for few feature.">
                          <span className="wcs_title">
                            <HelpOutlineIcon className="wcs_tooltip_icon" />
                          </span>
                        </Tippy>

                      </label>
                      <div className="wpnts-setting">
                        <input
                          type="text"
                          className="recipiantmail"
                          id="recipiantmail"
                          name="recipiantmail"
                          value={settings.recipiantmail}
                          onChange={handleRecipiantmail}
                        />


                      </div>
                    </div>
                  </div>
                </div>

                <div className="video-guide">
                  {/* <h4>Guide video: Slack webhook Integration</h4> */}
                  <div className='wcs-player-wrapper'>
                    <ReactPlayer
                      className='wcs-react-player'
                      url='https://youtu.be/wLytkvVOeJw'
                      width='100%'
                      height='100%'
                      controls={true}
                      light={true}
                      config={{
                        youtube: {
                          playerVars: {
                            modestbranding: 1,
                            showinfo: 0,
                          },
                        },
                      }}
                      iframe
                    />
                  </div>
                </div>


              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="wizard-step">
            <h3>Step 3: Configure Settings Panel</h3>
            <div className="wpnts-switch-sitessecurityissues">
              <div className="webhooks-panel">
                <div className="webhook-settings-panel">
                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id="active_user_activity"
                        onChange={handleToggle('active_user_activity')}
                        checked={settings.active_user_activity}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_user_activity">Enable user activity tracker</label>
                      <Tippy content="All site settings are available here. Activate this to automatically enable the essential activity tracker from the list.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>

                    {/* <div className="feature-list-parent">

                      {settings.active_user_activity && (
                        <div className="feature-list">
                          <p>Activating the User Activity Tracker enables the following features:</p>
                          <ul>
                            <li>Plugin Activation Notice</li>
                            <li>Plugin Deactivation Notice</li>

                          </ul>
                        </div>
                      )}
                    </div> */}

                  </div>


                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id="active_security_settings"
                        onChange={handleToggle('active_security_settings')}
                        checked={settings.active_security_settings}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_security_settings">Activate website security</label>
                      <Tippy content="Enable the website security tracker here. Activating this will automatically turn on key security monitoring features to keep your site safe.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>

                    {/* <div className="feature-list-parent">
                    </div> */}

                  </div>

                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_theme_security'
                        onChange={handleToggle('active_site_theme_security')}
                        checked={settings.active_site_theme_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_theme_security">Activate theme security</label>
                      <Tippy content="Enable the theme security tracker for your WordPress site. Activating this feature provides real-time monitoring to keep your themes secure and up-to-date.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>

                    {/* <div className="feature-list-parent">
                    </div> */}

                  </div>

                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_page_post_security'
                        onChange={handleToggle('active_site_page_post_security')}
                        checked={settings.active_site_page_post_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_page_post_security">Activate page and post security</label>
                      <Tippy content="Enable the page and post security tracker to monitor and protect your content in real-time, ensuring every page and post stays secure and safeguarded.You’ve hit the Free plan limit for GPT-4o.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>

                    {/* <div className="feature-list-parent">
                    </div> */}
                  </div>
                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_media_security'
                        onChange={handleToggle('active_site_media_security')}
                        checked={settings.active_site_media_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_media_security">Activate media security</label>
                      <Tippy content="Activate the media security tracker to safeguard your media files, ensuring all images, videos, and documents are monitored and protected against unauthorized access.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>

                    {/* <div className="feature-list-parent">
                    </div> */}
                  </div>

                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_menu_security'
                        onChange={handleToggle('active_site_menu_security')}
                        checked={settings.active_site_menu_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_menu_security">Activate menu security</label>
                      <Tippy content="Turn on the menu security tracker to keep your navigation menus secure, monitoring changes and preventing unauthorized modifications to your site’s structure.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>

                    {/* <div className="feature-list-parent">
                    </div> */}
                  </div>
                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_widgets_security'
                        onChange={handleToggle('active_site_widgets_security')}
                        checked={settings.active_site_widgets_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_widgets_security">Activate widgets security</label>
                      <Tippy content="Enable the widgets security tracker to protect your sidebar and footer widgets, ensuring that all widgets are securely monitored and unauthorized changes are promptly detected.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>
                    {/* <div className="feature-list-parent">
                    </div> */}
                  </div>


                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_woocommerce_security'
                        onChange={handleToggle('active_site_woocommerce_security')}
                        checked={settings.active_site_woocommerce_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_woocommerce_security">Activate WooCommerce and Order Tracker</label>
                      <Tippy content="This will active tracker for WooCommerce Product and Order.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>
                    {/* <div className="feature-list-parent">
                    </div> */}
                  </div>

                  <div className="media-feature configure-feature">
                    <div className="toggle-parent">
                      <ReactSwitchsupport
                        id='active_site_comment_security'
                        onChange={handleToggle('active_site_comment_security')}
                        checked={settings.active_site_comment_security}
                        height={20}
                        width={40}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      />
                      <label htmlFor="active_site_comment_security">Activate Comment Tracker</label>
                      <Tippy content="Enable the widgets Comment tracker to know all the comment, thoughts and actions.">
                        <span className="wcs_title">
                          <HelpOutlineIcon className="wcs_tooltip_icon" />
                        </span>
                      </Tippy>
                    </div>
                    {/* <div className="feature-list-parent">
                    </div> */}
                  </div>

                </div>


                <div className="video-guide">
                  <div className='wcs-player-wrapper'>
                    <ReactPlayer
                      className='wcs-react-player'
                      url='https://youtu.be/GedaQDZWQDI'
                      width='100%'
                      height='100%'
                      controls={true}
                      light={true}
                      config={{
                        youtube: {
                          playerVars: {
                            modestbranding: 1,
                            showinfo: 0,
                          },
                        },
                      }}
                      iframe
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        );

      case 4:
        return (
          <div className="wizard-step">
            <h3>Step 4: Finalize Cloudflare Turnstile for Enhanced Login Security</h3>
            <h4>➡️ You can configure Cloudflare at a later time. To bypass this setup, simply click the Next button.</h4>
            <div className="wpnts-switch-sitessecurityissues">
              <div className="media-feature">
                <Captcha />
              </div>
              <br />
              <a href="https://youtu.be/paAmoxg1048" target="_blank" className="single-doc-item">➡️ Cloudflare Turnstile setup video</a>
            </div>

          </div>
        );


      case 5:
        return (
          <div className="wizard-step">
            <h3>Step 5: Are You Currently having Any Plugins on the WordPress Forum?</h3>
            <h4>➡️ Add the plugin slug to track it, or click the Next button to skip this step.</h4>
            <a href="https://youtu.be/0LsPuBGu7YE" target="_blank" className="single-doc-item">➡️ WordPress plugin tracker quick setup video</a>
            <div className="wpnts-switch-sitessecurityissues">
              <div className="media-feature">
                <PluginList />
              </div>

            </div>

          </div>
        );

      case 6:
        return (
          <div className="wizard-step finished">
            <h3>Step 6: Complete the setup</h3>
            <div className="wpnts-switch-sitessecurityissues">
              <div className="media-feature">
                {/* Congratulations page */}

                {settings.active_user_activity &&
                  settings.active_security_settings &&
                  settings.active_site_theme_security &&
                  settings.active_site_page_post_security &&
                  settings.active_site_media_security &&
                  settings.active_site_menu_security &&
                  settings.active_site_woocommerce_security &&
                  settings.active_site_comment_security &&
                  settings.active_site_widgets_security ? (
                  <h3 className="complete-msg">Your website is now fully secured! 🎉 Click ➡️ 'Finish' to complete the setup and unlock peace of mind!</h3>
                ) : (
                  <div className="incomplete-msg">
                    <h3>Seems you missed some settings 😥</h3>
                    <p>Make sure to activate the following from the ⚙️ Configuration menu</p>
                    <div className="missing-settings">
                      {!settings.active_user_activity && <div className="setting-item">User Activity Tracker</div>}
                      {!settings.active_security_settings && <div className="setting-item">Security Settings</div>}
                      {!settings.active_site_theme_security && <div className="setting-item">Theme Security</div>}
                      {!settings.active_site_page_post_security && <div className="setting-item">Page/Post Security</div>}
                      {!settings.active_site_media_security && <div className="setting-item">Media Security</div>}
                      {!settings.active_site_menu_security && <div className="setting-item">Menu Security</div>}
                      {!settings.active_site_woocommerce_security && <div className="setting-item">WooCommerce and order Tracker</div>}
                      {!settings.active_site_comment_security && <div className="setting-item">Comment Tracker</div>}
                      {!settings.active_site_widgets_security && <div className="setting-item">Widgets Security</div>}
                    </div>
                  </div>
                )}


                <div className="contain">
                  <div className="congrats">
                    {settings.active_user_activity &&
                      settings.active_security_settings &&
                      settings.active_site_theme_security &&
                      settings.active_site_page_post_security &&
                      settings.active_site_media_security &&
                      settings.active_site_menu_security &&
                      settings.active_site_woocommerce_security &&
                      settings.active_site_comment_security &&
                      settings.active_site_widgets_security ? (
                      <h1>Congrat<span className="hide">ulation</span>s !</h1>
                    ) : (
                      <h1>Al<span className="hide">mos</span>t done!</h1>
                    )}

                    <div className="done">
                      <img className="setup_complete" src={verified} alt="staff" />
                    </div>
                  </div>
                </div>
              </div>
            </div>



          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="wcs_home_wizards">
      <div className="wcs_home_wizardsContainer">
        <div className="wizards-page-setup" id="wizards-page">
          <TransitionGroup>
            <CSSTransition key={currentStep} timeout={300} classNames="fade">
              <div className="step-container">{renderStep()}</div>
            </CSSTransition>
          </TransitionGroup>

          {/* Optional: Step Indicator */}
          <div className="wizard-step-indicator">
            Step {currentStep} of 6
          </div>

          <div className="wizard-navigation">
            {currentStep > 1 && (
              <button className="nav-button" onClick={handlePrevious}>
                <ArrowBackIosIcon className='prev-btn' /> Previous
              </button>
            )}
            {currentStep < 6 && (
              <button className="nav-button" onClick={handleNext}>
                Next <ArrowForwardIosIcon className='next prev-btn' />
              </button>
            )}
            {currentStep === 6 && (
              <button
                className="nav-button finish-button"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {/* {isSubmitting ? 'Submitting...' : 'Finish'} */}
                {isSubmitting ? 'Submitting...' : (
                  <>
                    <TaskAltIcon className='next prev-btn' /> Complete setup!
                  </>
                )}

              </button>
            )}
          </div>
        </div>
      </div>
      <NoticeModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        onConfirm={modalConfig.onConfirm}
        onDecline={closeModal}
        type={modalConfig.type}
        title={modalConfig.title}
        message={modalConfig.message}
        confirmText={modalConfig.confirmText}
        declineText={modalConfig.declineText}
        position={modalConfig.position || 'center'}
        autoClose={modalConfig.type === 'toast'}
        autoCloseTime={3000}
      />
    </div>
  );
};

export default Wizards;
